<template>
  <button>Investor Login</button>
</template>
